import type { RouteRecordRaw } from 'vue-router'
import IntroLayout from '@/layouts/IntroLayout.vue'
import Intro_3 from '@/views/intro/Intro_3.vue'


const routes: RouteRecordRaw[] = [
  {
    path: '/:lang(th|en)/:part(intro)',
    component: IntroLayout,
    children: [{ path: '3', component: Intro_3, meta: { next: '../intro/3' } }],
  },
]

export default routes
